<script>
    import {_, locale} from 'svelte-i18n';
    import {researchTypesIcons} from "../../globals.js";
    import {instantResearchTermBases} from "./instant-research.js";
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    // The sku-named term first, then the one named after the research (see instant-research.js).
    function term(suffix) {
        const [best, fallback] = instantResearchTermBases(item, gameItem);
        return fallback ? $_(best + suffix, {default: $_(fallback + suffix)}) : $_(best + suffix);
    }

    function setItemDetails() {
        itemDetails.title = term('Title');
        itemDetails.description = term('Description');
        itemDetails.amount = item.amount;
        itemDetails.icon = researchTypesIcons[gameItem.type];
        // The game config gives newer instant research items a rarity (packs 1231/1232: legendary);
        // the older ones have none and stay common.
        itemDetails.rarity = gameItem.rarity ?? 1;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
